import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/tree-view/rich-tree-view/editing/editing.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
